import React from 'react';

import { ContentBlock } from '@/lib/api';

interface StructuredDocRenderContextValue {
  shouldShowFloatingCard: (cref: string, block: ContentBlock) => boolean;
}

const StructuredDocRenderContext = React.createContext<StructuredDocRenderContextValue | null>(
  null
);

export function useStructuredDocRender(): StructuredDocRenderContextValue {
  const ctx = React.useContext(StructuredDocRenderContext);
  if (!ctx) {
    throw new Error(
      'useStructuredDocRender must be used within a StructuredDocRenderContext.Provider'
    );
  }
  return ctx;
}

export { StructuredDocRenderContext };
